'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib = require('tslib');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var getThemeProp = require('../../utils/getThemeProp.js');
var ClearRoundedIcon = _interopDefault(require('@material-ui/icons/ClearRounded'));

var ColoredIcon = styled__default(ClearRoundedIcon)(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject(["\n  fill: ", ";\n\n  width: 1.2rem;\n  height: 1.2rem;\n  margin-right: 0.3rem;\n"], ["\n  fill: ", ";\n\n  width: 1.2rem;\n  height: 1.2rem;\n  margin-right: 0.3rem;\n"])), getThemeProp('palette.error.dark', 'red'));
var StatusContainer = styled__default.div(templateObject_2 || (templateObject_2 = tslib.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var templateObject_1, templateObject_2;

exports.ColoredIcon = ColoredIcon;
exports.StatusContainer = StatusContainer;
